import { Credentials } from "auth";
import { Handler, Intent } from "generated/graphql";
import { ClientApp } from "models";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type TransferApp = "TRANSFER_APP";
export const TRANSFER_APP: TransferApp = "TRANSFER_APP";

export type TransferAppEnd = "TRANSFER_APP_END";
export const TRANSFER_APP_END: TransferAppEnd = "TRANSFER_APP_END";

export interface TransferAppAction extends Action {
    type: TransferApp;
    payload: {
        appId: string;
        credentials: Credentials;
        orgId: string;
    };
}

export function transferApp(appId: string, orgId: string): ThunkAction<any, State, any, TransferAppAction> {
    return (dispatch: Dispatch<TransferAppAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(transferAppWithCredentials(appId, orgId, credentials));
    };
}

function transferAppWithCredentials(appId: string, orgId: string, credentials: Credentials): TransferAppAction {
    return {
        payload: {
            appId,
            credentials,
            orgId
        },
        type: TRANSFER_APP
    };
}

export interface TransferAppEndAction extends Action {
    type: TransferAppEnd;
    payload: {
        error?: Error;
        app: ClientApp;
        intents: (Intent | Handler)[];
    };
}

export function transferAppEnd(error: Error, app?: ClientApp, intents?: (Intent | Handler)[]): TransferAppEndAction {
    return {
        payload: {
            app,
            error,
            intents
        },
        type: TRANSFER_APP_END
    };
}
